'use strict';

/*global app*/
/*global services*/
/*global invokeCallback*/

function TransferNoteService() {
  this.$container = $('body');

  this.fromStockId = null;
  this.toStockId = null;

  this.init();
}

TransferNoteService.prototype = $.extend({}, {
  constructor: 'TransferNoteService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.open-transfer-note-new', function () {
      _this.newTransferNote($(this).data('include_assigned') ? 1 : 0);

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  selectWarehouseFrom: function selectWarehouseFrom(callback) {
    var _this = this;

    services.get('warehouse-service').selectWarehouse({ title: app.t('transfer_note.from_stock') }, function (stockId) {
      _this.fromStockId = stockId;

      invokeCallback(callback);
    });

    return _this;
  },

  selectWarehouseTo: function selectWarehouseTo(callback) {
    var _this = this;

    services.get('warehouse-service').selectWarehouse({ title: app.t('transfer_note.to_stock') }, function (stockId) {
      _this.toStockId = stockId;

      invokeCallback(callback);
    });

    return _this;
  },

  newTransferNote: function newTransferNote(includeAssigned) {
    var _this = this;

    _this.selectWarehouseFrom(function () {
      _this.selectWarehouseTo(function () {
        location.href = app.path('transfer_note_new', { FromStockId: _this.fromStockId, ToStockId: _this.toStockId, IncludeAssigned: includeAssigned });
      });
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.registerCallbacks();

    return _this;
  }
});

